import { Icon, Text } from '@user-portal/wikr-components';
import React from 'react';

import { toISODateString } from 'helpers/dateParser';

import * as S from './MealItem.styled';

type MealItemProps = {
    id: number;
    mealType: string;
    name: string;
    kilocalories: number;
    cookingTime: number;
    cover: string;
    copy: {
        minutes: string;
        calories: string;
    };
    onClick: (mealType: string) => void;
    selectedDate: Date;
};

export const MealItem = ({
    id,
    mealType,
    name,
    kilocalories,
    cookingTime,
    cover,
    copy,
    onClick,
    selectedDate,
}: MealItemProps) => {
    const handleItemClick = () => {
        onClick(mealType);
    };

    return (
        <S.ItemContainer
            key={id}
            to={`/meals/${id}`}
            state={{ selectedDate: toISODateString(selectedDate) }}
            data-testid={`meal-item-${id}`}
            data-locator={`meal-item-${id}`}
            onClick={handleItemClick}
        >
            <S.Image src={cover} />
            <div>
                {mealType && (
                    <S.MealTag>
                        <Text type="caption">{mealType}</Text>
                    </S.MealTag>
                )}
                <Text type="small-text-medium" mb={4}>
                    {name}
                </Text>
                <Text type="small-text" color="text-secondary">
                    {cookingTime} {copy.minutes} {kilocalories} {copy.calories}
                </Text>
            </div>
            <S.IconContainer>
                <Icon name="arrowRight" color="text-main" />
            </S.IconContainer>
        </S.ItemContainer>
    );
};
